export const hasEnoughVetcoins = (balance: number, cost: number) =>
  balance >= cost;

export const nextBalanceAfterCredit = (balance: number, amount: number) =>
  balance + Math.max(0, amount);

export const nextBalanceAfterPurchase = (balance: number, cost: number) =>
  Math.max(0, balance - Math.max(0, cost));
